var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-2",attrs:{"flat":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-text-field',{attrs:{"outlined":"","dense":"","label":_vm.$t('title')},model:{value:(_vm.valueComputed.title),callback:function ($$v) {_vm.$set(_vm.valueComputed, "title", $$v)},expression:"valueComputed.title"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }